var version = {
    "name":      "dativery",
    "buildDateCode": "20260424-110542",
    "buildDate": "Fri Apr 24 2026 11:05:42 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260424-110542",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;